// SidebarAddClientFinance component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import currency from '../../../lib/currency.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import FieldTitle from '../../form/field_title/field_title.jsx'
import FieldText from '../../form/field_text/field_text.jsx'
import Button from '../../common/button/button.jsx'
import ContactRates from '../../../contact/common/contact_rates/contact_rates.jsx'

class SidebarAddClientFinance extends Component {
  constructor (props) {
    super(props)

    this._refs = {}
  }

  static get propTypes () {
    return {
      contact: PropTypes.object,
      defaultRateCards: PropTypes.array,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      contact: null,
      defaultRateCards: [],
      onChange: null
    }
  }

  _setFocusField (rateCardIndex, name) {
    const refKey = `${rateCardIndex}_${name}`
    if (this._refs[refKey]) {
      this._refs[refKey].focus()
    }
  }

  _createNewRateCardIfNotExists (rateCardIndex) {
    const { rateCards } = this.props.contact

    // Check index is last record or not
    if (rateCardIndex === rateCards.length - 1) {
      this._onAddRateCard()
    }
  }

  /* Handler Functions */
  _onChangeField (name, value) {
    const { onChange } = this.props
    if (onChange) {
      onChange(name, value)
    }
  }

  _onKeyDownRateCardField (rateCardIndex, name, ev) {
    // Process Tab or enter for name, amount fields
    if (ev.keyCode === 9 || ev.keyCode === 13) {
      ev.preventDefault()

      if (name === 'amount') {
        // If there is no more row, create a new one and after refresh, set the focus
        if (rateCardIndex === this.props.contact.rateCards.length - 1) {
          this._createNewRateCardIfNotExists(rateCardIndex)
          setTimeout(() => {
            this._setFocusField(rateCardIndex + 1, 'name')
          }, 400)
        } else {
          // Move to next row
          this._setFocusField(rateCardIndex + 1, 'name')
        }
      } else {
        this._setFocusField(rateCardIndex, 'amount')
        this._createNewRateCardIfNotExists(rateCardIndex)
      }
    } else if (name === 'amount') {
      this._onKeyDownField(name, ev)
    }
  }

  _onKeyDownField (name, ev) {
    // Prevent shift key since its not needed
    if (ev.shiftKey === true) {
      ev.preventDefault()
    }

    // Allow Only: keyboard 0-9, numpad 0-9, backspace, tab, left arrow, right arrow, delete
    if (
      (ev.keyCode >= 48 && ev.keyCode <= 57) ||
      (ev.keyCode >= 96 && ev.keyCode <= 105) ||
      ev.keyCode === 8 ||
      ev.keyCode === 9 ||
      ev.keyCode === 37 ||
      ev.keyCode === 39 ||
      ev.keyCode === 46
    ) {
      // Allow normal operation
    } else if (ev.keyCode === 190 && (name === 'rate' || name === 'amount')) {
      // Allow normal operation
    } else {
      // Prevent the rest
      ev.preventDefault()
    }
  }

  _onAddRateCard = () => {
    const { rateCards } = this.props.contact
    rateCards.push({
      name: '',
      amount: 0
    })
    this._onChangeField('rateCards', rateCards)
  }

  _onChangeRateCardField (rateCard, name, value) {
    const { rateCards } = this.props.contact
    if (name === 'amount') {
      rateCard.amount = isNaN(value) ? 0 : parseFloat(value)
    } else {
      rateCard[name] = value
    }

    this._onChangeField('rateCards', rateCards)
  }

  _onDeleteRateCard (rateCardIndex) {
    const { rateCards } = this.props.contact
    rateCards.splice(rateCardIndex, 1)

    this._onChangeField('rateCards', rateCards)
  }

  /* Other Render Functions */
  _renderRateCard (rateCard, rateCardIndex) {
    let isShowCurrency = false
    if (currency.getCurrency() === 'USD') {
      isShowCurrency = true
    }

    return (
      <div className='ratecard-item' key={`${rateCardIndex}`}>
        <div className='ratecard-colaction'>
          <div className='ratecard-delete'>
            <IconButton
              icon='x'
              size='normal'
              className='person-delete'
              canHover
              onClick={this._onDeleteRateCard.bind(this, rateCardIndex)}
            />
          </div>
        </div>
        <div className='ratecard-content'>
          <div className='ratecard-name'>
            <FieldText
              name='name'
              ref={ref => {
                this._refs[`${rateCardIndex}_name`] = ref
              }}
              value={rateCard.name}
              onChange={this._onChangeRateCardField.bind(
                this,
                rateCard,
                'name'
              )}
              onKeyDown={this._onKeyDownRateCardField.bind(
                this,
                rateCardIndex,
                'name'
              )}
            />
            {!rateCard.name && (
              <FieldTitle title='projectV2.sidebarFinance.name' />
            )}
          </div>
          <div className='ratecard-amount'>
            <div
              className={`field-colsymbol${
                isShowCurrency ? ' symbol-usd' : ''
              }`}
            >
              {currency.symbol()}
            </div>
            <FieldText
              name='amount'
              ref={ref => {
                this._refs[`${rateCardIndex}_amount`] = ref
              }}
              value={rateCard.amount}
              onChange={this._onChangeRateCardField.bind(
                this,
                rateCard,
                'amount'
              )}
              onKeyDown={this._onKeyDownRateCardField.bind(
                this,
                rateCardIndex,
                'amount'
              )}
            />
            <FieldTitle title='projectV2.sidebarFinance.rateType' />
          </div>
        </div>
      </div>
    )
  }

  _renderRateCards () {
    const { rateCards } = this.props.contact

    return (
      <div className='finance-ratecards'>
        {rateCards.map((rateCard, rateCardIndex) =>
          this._renderRateCard(rateCard, rateCardIndex)
        )}
        <Button
          title='projectV2.sidebarFinance.addRateCard'
          className='copybutton'
          onClick={this._onAddRateCard} // eslint-disable-line react/jsx-handler-names
        />
      </div>
    )
  }

  _renderField (title, identifier, infoTitle, bIsPrice) {
    let isShowCurrency = false
    if (currency.getCurrency() === 'USD') {
      isShowCurrency = true
    }
    const { contact } = this.props
    return (
      <div className='finance-field'>
        <div className='field-title'>
          <FieldTitle title={title} />
        </div>
        <div className='field-content'>
          {bIsPrice && (
            <div
              className={`field-colsymbol${
                isShowCurrency ? ' symbol-usd' : ''
              }`}
            >
              {currency.symbol()}
            </div>
          )}
          <div className='field-colvalue'>
            <FieldText
              name={identifier}
              value={`${contact[identifier]}`}
              onChange={this._onChangeField.bind(this, identifier)}
              onKeyDown={this._onKeyDownField.bind(this, identifier)}
            />
          </div>
          <div className='field-colinfo'>
            <FieldTitle title={infoTitle} />
          </div>
        </div>
      </div>
    )
  }

  _renderRateCardInfo () {
    const { defaultRateCards } = this.props

    return (
      <ContactRates
        title='contact.form.defaultRateTitleInfo'
        note='contact.form.defaultRateNoteInfo'
        items={defaultRateCards}
      />
    )
  }

  /* Render Function */
  render () {
    return (
      <div className='sidebar-finance'>
        <div className='finance-colform'>
          {this._renderField(
            'projectV2.sidebarFinance.rateCard',
            'rate',
            'projectV2.sidebarFinance.defaultRate',
            true
          )}
          {this._renderRateCards()}
          {this._renderField(
            'projectV2.sidebarFinance.markupPercentage',
            'rateMarkup',
            'projectV2.sidebarFinance.percentageMarkup',
            false
          )}
          {this._renderField(
            'projectV2.sidebarFinance.paymentDays',
            'paymentDays',
            'projectV2.sidebarFinance.days',
            false
          )}
        </div>
        <div className='finance-colinfo'>{this._renderRateCardInfo()}</div>
      </div>
    )
  }
}

export default SidebarAddClientFinance
